import PropTypes from 'prop-types';
import cx from 'classnames';
import { BrandLogo } from '@shared/ui';
import './AppLoader.css';

/**
 * AppLoader — full-screen boot loader.
 *
 * Surface matches the dashboard background (white in light theme,
 * deep navy in dark theme) so the boot → dashboard handoff is a pure
 * opacity dissolve with no colour swap. The brand mark inherits its
 * tint from the loader's `color` CSS variable, which the stylesheet
 * keys off `[data-theme]` — that single property tints both glyph
 * parts because BrandLogo with `tone="inherit"` uses currentColor.
 *
 * Props:
 *   - isHiding: boolean — when true, the loader fades out and lets
 *     the page underneath take over.
 *   - tagline: optional small text under the wordmark.
 */
const AppLoader = ({ isHiding = false, tagline }) => (
  <div
    className={cx('qhs-app-loader', isHiding && 'qhs-app-loader--hiding')}
    role="status"
    aria-live="polite"
    aria-busy={!isHiding}
  >
    <div className="qhs-app-loader__content">
      <BrandLogo
        variant="wordmark"
        tone="inherit"
        size={240}
        animated
        className="qhs-app-loader__logo"
      />
      {tagline && <p className="qhs-app-loader__tagline">{tagline}</p>}
      <div className="qhs-app-loader__progress" aria-hidden="true">
        <span className="qhs-app-loader__progress-bar" />
      </div>
    </div>
  </div>
);

AppLoader.propTypes = {
  isHiding: PropTypes.bool,
  tagline: PropTypes.string,
};

export default AppLoader;
